export function useApiLocaleUrl() {
    const { locale } = useI18n();
    return (endpoint: string, query?: URLSearchParams): string => {
        query ??= new URLSearchParams();
        query.append("lang", locale.value);
        return `/${endpoint}?${query.toString()}`;
    };
}

export function useLangPath() {
    const { locale } = useI18n();
    return (path: string): string => {
        return `/${locale.value}${path}`;
    };
}
